import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import Helmet from 'helmet/helmet';
import Styled from 'styled';

import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';
import { Site } from 'four-nets/site';
import TitleView from 'four-nets/ui/title-view';
import { CategoryStore } from 'four-nets/forum/forum';
import newArticle from 'four-nets/icons/svg/icon_new-article.svg';
import BigButtonView from 'four-nets/ui/big-button/big-button-view';
import NewThreadView, { NewThreadViewModel } from 'four-nets/forum/thread/new-thread/new-thread-view';
import { HideForVendor } from 'four-nets/vendor/permissions';
import ThreadsTableView from 'four-nets/forum/threads-table/threads-table-view';

import titleViewStyles from '../title-view-styles.scss';
import defaultStyles from './where-i-posted-view.scss';

@Styled(defaultStyles)
@observer
class WhereIPostedView extends React.Component {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
        categoryStore: PropTypes.instanceOf(CategoryStore),
        authCheck: PropTypes.func,
    };

    constructor(props, context) {
        super(props);

        const { categoryStore, site } = context;
        categoryStore.site = site;

        this.newThreadViewModel = new NewThreadViewModel({
            categoryStore,
            userStore: categoryStore.userStore,
        });
    }

    newThreadViewModel: NewThreadViewModel;
    newThreadView: NewThreadView | undefined;

    setNewThreadView = (ref: ?NewThreadView) => {
        this.newThreadView = ref;
    };

    onNewThreadClick = () => {
        const { newThreadView } = this;

        if (newThreadView) {
            const action = () => {
                newThreadView.show({
                    form: this.newThreadViewModel.setupForm(),
                });
                return Promise.resolve();
            };

            this.context.authCheck(action, AuthOrigin.NewThread);
        }
    };

    renderHelmet = H => {
        const { site } = this.context;
        return (
            <FormattedMessage id='FORUM_LINK_LABEL'>
                {linkLabel => (
                    <FormattedMessage id='FORUM_WHERE_I_POSTED_TITLE'>
                        {whereIPostedTitle => {
                            const title = `${linkLabel} - ${whereIPostedTitle} | ${site.name}`;

                            return (
                                <H>
                                    <title>{title}</title>
                                    <meta property='og:title' content={title} />
                                </H>
                            );
                        }}
                    </FormattedMessage>
                )}
            </FormattedMessage>
        );
    };

    render() {
        const { styles, loading, threadsTableViewModel } = this.props;
        const { newThreadViewModel } = this;

        return (
            <div className={styles.whereIPosted}>
                <div>
                    <Helmet render={this.renderHelmet} />
                    <TitleView
                        style={{ components: titleViewStyles.titleViewComponents }}
                        title={
                            <FormattedMessage id='WHERE_DID_I_REACTED' values={{ gender: 'm' }}>
                                {msg => <h1 className={styles.heading}>{msg}</h1>}
                            </FormattedMessage>
                        }
                        leftComponent={
                            <HideForVendor>
                                <BigButtonView
                                    icon={newArticle}
                                    label={<FormattedMessage id='NEW_THREAD_BUTTON' />}
                                    onClick={this.onNewThreadClick}
                                />
                            </HideForVendor>
                        }
                    />
                </div>
                <ThreadsTableView loading={loading} threadsTableViewModel={threadsTableViewModel} />
                <NewThreadView innerRef={this.setNewThreadView} newThreadViewModel={newThreadViewModel} />
            </div>
        );
    }
}

export default WhereIPostedView;
